import { TextLink } from '@dsg-tech/homefield-react';
import { useAppSelector } from 'store/store';
import {
  storeIdSelector,
  storeNameSelector,
  getFeatureFlagByNameSelector,
  storeIdentifierNameSelector,
} from 'store/selectors/commonSelector';
import useLogger from 'hooks/useLogger';
import FooterLogo from 'common/FooterLogo/FooterLogo';
import TopMessages from './TopMessages/TopMessages';
import MiddleSection from './MiddleSection/MiddleSection';
import ErrorBoundaryWithLogger from '../../common/ErrorBoundary/ErrorBoundary';
import './Footer.scss';
import FooterLinksContainer from './FooterLinks/FooterLinksContainer';
import MobileAccordionContainer from './MobileAccordion/MobileAccordionContainer';
import FooterColumnContainer from './FooterColumnContainer';

const Footer = () => {
  const storeId = useAppSelector(storeIdSelector);
  const storeName = useAppSelector(storeNameSelector);
  const headerLogoNetStorageEnabled = useAppSelector(
    getFeatureFlagByNameSelector('headerLogoNetStorageEnabled'),
  );
  const storeIdentifierName = useAppSelector(storeIdentifierNameSelector);
  const { error } = useLogger();

  try {
    return (
      <div data-testid="footer">
        <ErrorBoundaryWithLogger componentId="Footer-TopMessages">
          <TopMessages />
        </ErrorBoundaryWithLogger>
        <ErrorBoundaryWithLogger componentId="Footer-MiddleSection">
          <MiddleSection />
        </ErrorBoundaryWithLogger>
        <ErrorBoundaryWithLogger componentId="Footer-MobileAccordionContainer">
          <MobileAccordionContainer />
        </ErrorBoundaryWithLogger>
        <ErrorBoundaryWithLogger componentId="Footer-FooterColumnContainer">
          <FooterColumnContainer />
        </ErrorBoundaryWithLogger>

        <div className="footer-bottom-section hmf-display-flex hmf-flex-column hmf-align-items-center hmf-py-l hmf-px-s hmf-px-md-m">
          <div className="footer-bottom-details">
            {/* Remove G3 logo from footer after moving to new logo architecture for G3. No logo is shown in footer for G3. In future, Footer logo will be removed for other brands too. */}
            {headerLogoNetStorageEnabled && storeIdentifierName !== 'g3' && (
              <div className="hmf-display-flex hmf-justify-content-center">
                <div className="hmf-mb-l">
                  <FooterLogo />
                </div>
              </div>
            )}

            <div
              data-testid="footer-copyright"
              className="hmf-body-s hmf-text-align-center hmf-mb-xs">
              <span>
                &copy; {new Date().getFullYear()} {storeName}
              </span>
            </div>
            <div className="hmf-body-s hmf-mb-m hmf-text-align-center">
              *Price Promotions - Due to manufacturer restrictions, select new release and other
              specified products are excluded from price promotions. Additionally, there are
              restrictions on the use of coupon codes.
            </div>
            <div className="hmf-body-s hmf-mb-m hmf-text-align-center">
              <span data-testid="footer-screen-reader-msg">
                If you are using a screen reader and are having problems using this website, please
                call{' '}
                <TextLink
                  variant="tertiary"
                  size="small"
                  href={storeId === 10701 ? 'tel:800-287-9060' : 'tel:8778469997'}>
                  {storeId === 10701 ? ' 800-287-9060 ' : ' 877-846-9997 '}
                </TextLink>{' '}
                for assistance.
              </span>
            </div>
            <ErrorBoundaryWithLogger componentId="Footer-FooterLinksContainer">
              <FooterLinksContainer />
            </ErrorBoundaryWithLogger>
          </div>
        </div>
      </div>
    );
  } catch (e) {
    error('Could not load Footer - ', e);
    return null;
  }
};

export default Footer;
